/**
 * Home, dashboard and settings — the routes every signed-in user has.
 *
 * Part of the route table (see ./index.ts). Split by domain so adding a
 * screen touches one small file instead of one long one.
 */
import { lazy } from "react";
import type { AppRoute } from "./types";

export const CORE_ROUTES: AppRoute[] = [
  {
    path: "/",
    title: "Accueil",
    // Dispatches on role — see pages/home/HomePage.tsx. A parent used to land
    // on the director's overview with every tile showing a dash.
    component: lazy(() => import("@/pages/home/HomePage")),
    nav: { label: "Accueil", order: 1, mobile: 1 },
  },
  {
    path: "/dashboard",
    title: "Tableau de bord",
    component: lazy(() => import("@/pages/dashboard/DashboardPage")),
  },
  {
    path: "/settings",
    title: "Paramètres",
    component: lazy(() => import("@/pages/settings/SettingsPage")),
    nav: { label: "Paramètres", order: 90, group: "Mon compte" },
  },
  {
    // The only screen whose audience is a family rather than staff. No `perms`:
    // the backend decides what a session may see, and a parent holds no
    // school-side permission codes at all — gating on one here would hide the
    // portal from exactly the people it is for.
    path: "/family",
    title: "Espace famille",
    component: lazy(() => import("@/pages/family-portal/FamilyPortalPage")),
    // No nav entry: "/" already IS this screen for a parent or a student, and
    // staff have no family to look at. The route stays addressable because the
    // child switcher links to /family?student=<id>.
  },
];
